import styled from 'styled-components';

export const Spinner = styled.img<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  animation: search-spin infinite 2s linear;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  @keyframes search-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const CenterSpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

type SpinnerType = {
  size?: number;
  color?: 'white' | 'blue';
  className?: string;
};

const spinnerColors = {
  blue: '/assets/images/loading-spinner.png',
  white: '/assets/images/loading-spinner-white.png',
};

const LoadingSpinner: React.FC<SpinnerType> = ({
  size = 80,
  color = 'blue',
}) => {
  return (
    <Spinner
      data-testid="loading-spinner"
      src={spinnerColors[color]}
      size={size}
      alt="searching"
    />
  );
};

export const CenterSpinner: React.FC<SpinnerType> = ({
  size = 80,
  color = 'blue',
  className,
}) => (
  <CenterSpinnerWrapper className={className}>
    <LoadingSpinner color={color} size={size} />
  </CenterSpinnerWrapper>
);

export default LoadingSpinner;
